import { Image } from "antd";

export const renderCover = ({ record }: any) =>
    record?.banner ? <Image src={record?.banner} width={70} /> : "no cover";
